
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"42","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M37.8 0H4.2C1.869 0 .021 1.869.021 4.2L0 29.4c0 2.331 1.869 4.2 4.2 4.2h33.6c2.331 0 4.2-1.869 4.2-4.2V4.2C42 1.869 40.131 0 37.8 0zm0 29.4H4.2V16.8h33.6v12.6zm0-21H4.2V4.2h33.6v4.2z","fill":"#0095DA"}})])
          )
        }
      }
    